<template>
  <block style="padding-bottom: 30px;">
    <template slot="header">
      Nueva atención
    </template>

    <div class="msg">
      <h4 class="is-uppercase">atención registrada exitosamente</h4>
      <p class="is-marginless">Ahora puedes agregar otra atención para el estudiante</p>
    </div>

    <div class="actions">
      <button class="button is-primary" @click="navigateTo('app.profile.add_attention')">
        Sí, agendar atención
      </button>
      <button class="button" @click="navigateTo('app.profile.attentions')">No, volver</button>
    </div>
  </block>
</template>

<script>
import Block from "@/components/_base/Block.vue"
import OverlayedMixin from "@/mixins/OverlayedMixin"

export default {
  name: "ProfileAttentionCreated",
  mixins: [OverlayedMixin],
  components: {
    Block
  },
  methods: {
    navigateTo(route) {
      console.log(`Navigating to...${route}`)
      this.$emit("hello", route)
    }
  }
}
</script>

<style scoped>
.msg {
  margin-bottom: 70px;
}
.msg h4 {
  color: #449d7a;
}
</style>
